import ScalarCheckboxInput_vue_vue_type_script_setup_true_lang_default from "./ScalarCheckboxInput.vue.script.js";
//#region src/components/ScalarCheckboxInput/ScalarCheckboxInput.vue
var ScalarCheckboxInput_default = ScalarCheckboxInput_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCheckboxInput_default as default };

//# sourceMappingURL=ScalarCheckboxInput.vue.js.map